import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@electric-sql+pglite@0.2.13_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0._e4c2c47b1fff6881a4ed34ec8e518833/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}